import { getCountryForSiteByLocale, getCurrencyForSiteByLocale } from "@config/site/site-config";
import { PRODUCT_IMAGE_PLACEHOLDER_URL } from "@ui/components/media-and-icons/image/imagePaths";
import type { SearchIndex } from "algoliasearch";
import type { AlgoliaProduct, AlgoliaRelatedProduct, BrowseParams } from "./types";
import { getRelatedProductImageThumbnails } from "@components/commerce/product/right-panel/buy-card/utils";

export function normalizeAlgoliaProducts(products: AlgoliaProduct[]) {
    return products.map((hit) => ({
        ...hit,
        image: hit.image || PRODUCT_IMAGE_PLACEHOLDER_URL,
        images: hit.images?.length ? hit.images : [PRODUCT_IMAGE_PLACEHOLDER_URL],
        productColors:
            hit.productColors?.map((color) => ({
                ...color,
                priceWithDiscount: color.priceRaw,
                priceWithoutDiscount: color.listPriceRaw,
                image: color.image || PRODUCT_IMAGE_PLACEHOLDER_URL,
            })) ?? [],
    }));
}

export function normalizedBrowseObjects(indexToBrowse: SearchIndex, params: BrowseParams) {
    return indexToBrowse.browseObjects({
        ...params,
        ...(params.batch && {
            batch: (batch: AlgoliaProduct[]) => {
                const normalizedBatch = normalizeAlgoliaProducts(batch);

                if (params.batch) {
                    params.batch(normalizedBatch);
                }
            },
        }),
    });
}

export function normalizeRelatedProduct(algoliaProduct: AlgoliaProduct): AlgoliaRelatedProduct {
    return {
        variants: algoliaProduct?.variants || [],
        categories: algoliaProduct?.categories || [],
        imageThumbnails: getRelatedProductImageThumbnails(algoliaProduct),
        eaBadge: algoliaProduct?.eaBadge || null, // Early access badge
    };
}

export function getAlgoliaIndexName(locale: string) {
    const env = process.env.NEXT_PUBLIC_CONTENTFUL_ENVIRONMENT === "master" ? "prod" : "test";
    const country = getCountryForSiteByLocale(locale);
    const currency = getCurrencyForSiteByLocale(locale);
    return `${env.toLowerCase()}_${country}_${locale}_${currency}_Products`;
}

export function getAlgoliaIndexNameStores() {
    const env = process.env.NEXT_PUBLIC_CONTENTFUL_ENVIRONMENT === "master" ? "prod" : "test";

    return `${env.toLowerCase()}_Stores`;
}
